import { PROJECTS } from "../../data/projects";
import ProjectTile from "./ProjectTile";

/**
 * @param {{ onOpen: (id: string) => void }} props
 */
export default function ProjectGrid({ onOpen }) {
  return (
    <section className="projects-page" aria-label="Projects">
      <div className="projects-page__intro">
        <div className="projects-page__eyebrow">PROJECTS · {PROJECTS.length} SELECTED</div>
        <div className="projects-page__header">
          <h1 className="projects-page__title">Projects</h1>
          <p className="projects-page__blurb">
            Bodies of work with a beginning, a middle and a point — long-running
            series, commissions and personal obsessions.
          </p>
        </div>
      </div>

      <div className="projects-page__grid">
        {PROJECTS.map((project, index) => (
          <ProjectTile key={project.id} project={project} onOpen={onOpen} index={index} />
        ))}
      </div>
    </section>
  );
}
